import styled from 'styled-components';

import { Box } from '../../../../common/ui/Box';
import { theme } from '../../../../common/ui/theme';

export const OfferChatWrapper = styled(Box).attrs({
    width: '20%',
    height: '100%',
    position: 'absolute',
    right: 0,
})`
    border-left: 1px solid ${theme.colors.border.muted};
`;
